import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { auth } from '@/utils/firebase';

/**
 * The admin API. Always sends the Firebase ID token, whatever the firebaseToken flag says;
 * the API checks its isFolioAdmin claim. Each admin area adds its endpoints with
 * adminApi.injectEndpoints in its own …Api.js.
 */
export const adminApi = createApi({
	reducerPath: 'adminApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_FOLIO_ADMIN_API_ENDPOINT}/v1`,
		prepareHeaders: async (headers) => {
			const token = await auth.currentUser?.getIdToken();
			if (token) {
				headers.set('Authorization', token);
			}
			return headers;
		},
	}),
	tagTypes: [
		'ADMIN_USER',
		'ADMIN_BROKER_GROUP',
		'ADMIN_FEATURE_FLAG',
		'ADMIN_FORM_FIELD_CONFIG',
		'ADMIN_CLIENT',
		'ADMIN_CLAIM',
		'ADMIN_IMPORT',
	],
	endpoints: () => ({}),
});
